export default __webpack_public_path__ + "static/media/Time.84f084fe.svg";